import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { Scrollbar as ScrollbarComponent } from '@antv/gui';
/**
 * Scrollbar component.
 */
export var Scrollbar = function Scrollbar(options) {
  var orientation = options.orientation,
    labelFormatter = options.labelFormatter,
    style = options.style,
    rest = __rest(options, ["orientation", "labelFormatter", "style"]);
  return function (_ref) {
    var _ref$scales = _slicedToArray(_ref.scales, 1),
      scale = _ref$scales[0],
      value = _ref.value,
      theme = _ref.theme;
    var bbox = value.bbox;
    var x = bbox.x,
      y = bbox.y,
      width = bbox.width,
      height = bbox.height;
    var _theme$scrollbar = theme.scrollbar,
      scrollbarTheme = _theme$scrollbar === void 0 ? {} : _theme$scrollbar;
    var _scale$getOptions = scale.getOptions(),
      ratio = _scale$getOptions.ratio,
      range = _scale$getOptions.range;
    var mainSize = orientation === 'horizontal' ? width : height;
    var actualSize = mainSize / ratio;
    var _range = _slicedToArray(range, 2),
      r0 = _range[0],
      r1 = _range[1];
    var value1 = r1 > r0 ? 0 : 1;
    return new ScrollbarComponent({
      className: 'g2-scrollbar',
      style: Object.assign({}, scrollbarTheme, Object.assign(Object.assign(Object.assign(Object.assign({}, style), {
        x: x,
        y: y,
        trackLength: mainSize,
        value: value1
      }), rest), {
        orientation: orientation,
        contentLength: actualSize,
        viewportLength: mainSize
      }))
    });
  };
};
Scrollbar.props = {
  defaultPosition: 'bottom',
  defaultSize: 24,
  defaultOrder: 1,
  defaultCrossPadding: [12, 12],
  defaultPadding: [12, 12]
};